import React, { useState, useEffect } from "react";
import RopeBlue from "../../../../../Asset/icon/rope_blue.svg";
import { Form } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { getYachtInfoSellingPriceRatePlanListDetail } from "../../../../../redux/YachtInfoSellingPriceRatePlanList/YachtInfoSellingPriceRatePlanListSlice";
import { getYachtTypesDetail } from "../../../../../redux/YachtTypes/YachtTypesSlice";
import { useTranslation } from "react-i18next";
import "./customCheckbox.css";

const SelectTrip = ({ selectTrips, setSelectTripFilter, preSelectTrip }) => {
  const { t } = useTranslation();
  const [selectedTypes, setSelectedTypes] = useState(Array.from(preSelectTrip));
  const todos = useSelector((state) => state);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      dispatch(getYachtInfoSellingPriceRatePlanListDetail({})),
      dispatch(getYachtTypesDetail({})),
    ])
      .then(() => {
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, [dispatch]);

  const YachtTypes = loading
    ? []
    : todos.YachtInfoSellingPriceRatePlanListSlice
      .YachtInfoSellingPriceRatePlanList.results;

  useEffect(() => {
    setSelectTripFilter(selectedTypes);
  }, [selectedTypes, setSelectTripFilter]);

  const handleCheckboxChange = (event) => {
    const selectedTypes = event.target.value;
    setSelectedTypes((prevSelected) =>
      prevSelected.includes(selectedTypes)
        ? prevSelected.filter((type) => type !== selectedTypes)
        : [...prevSelected, selectedTypes]
    );
  };

  const handleClearFilter = () => {
    setSelectedTypes([]);
  };

  return (
    <div className="d-flex flex-column align-items-center position-relative">
      <div className="mb-4">
        <div
          className="absolute-left-text"
        >
          {t("Select Trip")}
        </div>
        <div
          className="absolute-right-link"
        >
          <a onClick={handleClearFilter}>{t("CLEAR")}</a>
        </div>
      </div>
      <div className="mt-4 w-80-percent">
        <Form className="d-flex flex-column align-items-start ">
          {Array.from(new Set(selectTrips)).map((type) => (
            <Form.Check
              className="custom-checkbox"
              key={type}
              type="checkbox"
              id={type}
              label={
                <div className="text-left">
                  {type} (
                  {
                    YachtTypes.filter((yacht) => yacht.rate_type === type)
                      .length
                  }
                  )
                </div>
              }
              value={type}
              onChange={handleCheckboxChange}
              checked={selectedTypes.includes(type)}
            />
          ))}
        </Form>
      </div>
      <div>
        <img className="m-4" draggable={false} src={RopeBlue} alt="RopeBlue" />
      </div>
    </div>
  );
};

export default SelectTrip;
